import { styled } from "@linaria/react"
import * as ToggleGroupPrimitive from "@radix-ui/react-toggle-group"

type ToggleGroupProps = ToggleGroupPrimitive.ToggleGroupSingleProps & {
  centered?: string
}

export const ToggleGroup = (props: ToggleGroupProps) => {
  return (
    <ToggleGroupRoot {...props}>
      {props.children}
    </ToggleGroupRoot>
  )
}

const ToggleGroupRoot = styled(ToggleGroupPrimitive.Root)<{
  centered?: string
}>`
  display: flex;
  align-items: center;
  justify-content: ${props => props.centered === "true" ? "center" : "normal"};
  gap: 8px;
`
